import wasFirstPageLoadedMostRecently from "../state/modules/search/domains/pagination/selectors/wasFirstPageLoadedMostRecently";
import { getItemCount } from "../state/modules/search";
import { getCategoryId } from "../state/modules/category";
import { MINIMUM_SEARCH_RESULTS_FOR_CAROUSEL } from "../components/UpSellCarousel/constants";

const CAROUSEL_CATEGORIES = {
  2426: {
    carouselCatId: 51206,
  },
  21867: {
    carouselCatId: 26416,
  },
  5678: {
    carouselCatId: 25399,
  },
  2238: {
    carouselCatId: 21007,
  },
  13210: {
    carouselCatId: 21007,
  },
};

const getCarouselCategory = (state) =>
  CAROUSEL_CATEGORIES[getCategoryId(state)];

const getChildCategoryID = (state) => {
  const itemCount = getItemCount(state);

  if (
    !wasFirstPageLoadedMostRecently(state) ||
    itemCount < MINIMUM_SEARCH_RESULTS_FOR_CAROUSEL
  ) {
    return;
  }

  const { carouselCatId } = getCarouselCategory(state) || {};

  return carouselCatId;
};

export default getChildCategoryID;
